/*
 * Majova Point – cookie consent (SPEC §5, §11). Vanilla ES2018, no dependencies.
 *
 * window.MPConsent.analytics()  true only if the visitor granted analytics
 * window.MPConsent.open()       opens the settings dialog (also any [data-mp-consent-open])
 * document 'mp:consent'         CustomEvent, detail {analytics:boolean}, after every choice
 *
 * GTM (window.MP.gtmId) is injected only after analytics consent, and only once per page.
 */
(function () {
  'use strict';

  var w = window;
  var d = document;
  if (w.MPConsent) return;

  var KEY = 'mp_consent';
  var MAX_AGE_MS = 365 * 24 * 60 * 60 * 1000; // older choices count as no choice (banner again)
  var GTM_ID = /^GTM-[A-Z0-9]+$/;
  var GA_COOKIE = /^(_ga|_ga_.+|_gid|_gat|_gat_.+|_gac_.+)$/;

  var choice = readChoice(); // true | false | null (no choice yet)
  var gtmLoaded = false;
  var opener = null;
  var banner = null;
  var dialog = null;
  var toggle = null;
  var nativeDialog = false;

  /* ---------- storage (every access in try/catch) ---------- */

  function readChoice() {
    try {
      var c = JSON.parse(w.localStorage.getItem(KEY) || 'null');
      if (c && c.v === 1 && typeof c.analytics === 'boolean' &&
          typeof c.ts === 'number' && Date.now() - c.ts <= MAX_AGE_MS) return c.analytics;
    } catch (e) {}
    return null;
  }

  function writeChoice(a) {
    try {
      w.localStorage.setItem(KEY, JSON.stringify({ v: 1, analytics: a, ts: Date.now() }));
    } catch (e) {
      // Storage blocked: the choice still applies for this page view (kept in memory).
    }
  }

  // Same rule as MPCore.isQA(): ?mp_qa=1 sets it, ?mp_qa=0 clears it, otherwise the stored flag.
  // Read here too because this script runs before mp-core.js stores the URL flag.
  function isQA() {
    var p = null;
    try {
      p = new URLSearchParams(w.location.search).get((w.MP && w.MP.qaParam) || 'mp_qa');
    } catch (e) {}
    if (p === '1') return true;
    if (p === '0') return false;
    try {
      return JSON.parse(w.localStorage.getItem('mp_qa') || 'false') === true;
    } catch (e) {
      return false;
    }
  }

  /* ---------- Google ---------- */

  function gtag() {
    w.dataLayer = w.dataLayer || [];
    if (typeof w.gtag === 'function') w.gtag.apply(w, arguments);
    else w.dataLayer.push(arguments);
  }

  function consentUpdate(a) {
    gtag('consent', 'update', { analytics_storage: a ? 'granted' : 'denied' });
  }

  function loadGTM() {
    if (gtmLoaded) return;
    var cfg = w.MP || {};
    var id = String(cfg.gtmId || '').trim().toUpperCase();
    if (!GTM_ID.test(id)) return;
    if (w.Shopify && w.Shopify.designMode) return; // never inside the theme editor
    gtmLoaded = true;
    w.dataLayer = w.dataLayer || [];
    // QA/internal flag must be in the dataLayer before gtm.js so the Google tag config reads it.
    if (isQA()) w.dataLayer.push({ traffic_type: 'internal' });
    w.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    var s = d.createElement('script');
    s.async = true;
    s.src = 'https://www.googletagmanager.com/gtm.js?id=' + encodeURIComponent(id);
    (d.head || d.documentElement).appendChild(s);
  }

  function deleteGaCookies() {
    var names = [];
    String(d.cookie || '').split(';').forEach(function (part) {
      var name = part.split('=')[0].trim();
      if (GA_COOKIE.test(name) && names.indexOf(name) < 0) names.push(name);
    });
    if (!names.length) return;

    var host = w.location.hostname || '';
    var domains = ['']; // '' = host-only cookie
    if (host.indexOf('.') > 0 && !/^[\d.]+$/.test(host)) {
      var parts = host.split('.');
      for (var i = 0; i < parts.length - 1; i++) {
        var dom = parts.slice(i).join('.');
        domains.push(dom, '.' + dom);
      }
    }
    names.forEach(function (name) {
      domains.forEach(function (dom) {
        d.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; max-age=0; path=/' +
          (dom ? '; domain=' + dom : '');
      });
    });
  }

  /* ---------- Shopify Customer Privacy API (guarded) ---------- */

  function syncShopify(a, done) {
    var finished = false;
    function finish() {
      if (finished) return;
      finished = true;
      if (done) done();
    }
    var consent = { analytics: a, marketing: false, preferences: false, sale_of_data: false };
    function set() {
      try {
        w.Shopify.customerPrivacy.setTrackingConsent(consent, finish);
      } catch (e) {
        finish();
      }
    }
    try {
      var S = w.Shopify;
      if (S && S.customerPrivacy && typeof S.customerPrivacy.setTrackingConsent === 'function') {
        set();
      } else if (S && typeof S.loadFeatures === 'function') {
        S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
          if (err || !w.Shopify.customerPrivacy) finish();
          else set();
        });
      } else {
        finish();
        return;
      }
    } catch (e) {
      finish();
      return;
    }
    if (done) w.setTimeout(finish, 1500); // never let a slow API block the reload
  }

  /* ---------- choice ---------- */

  function emit(a) {
    var ev;
    try {
      ev = new CustomEvent('mp:consent', { detail: { analytics: a } });
    } catch (e) {
      ev = d.createEvent('CustomEvent');
      ev.initCustomEvent('mp:consent', false, false, { analytics: a });
    }
    d.dispatchEvent(ev);
  }

  function choose(a) {
    a = a === true;
    var withdrawn = choice === true && !a;
    choice = a;
    writeChoice(a);
    consentUpdate(a);
    hideBanner();
    closeDialog();
    emit(a);
    if (a) {
      loadGTM();
      syncShopify(true);
    } else if (withdrawn) {
      deleteGaCookies();
      syncShopify(false, function () {
        deleteGaCookies();
        w.location.reload();
      });
    } else {
      syncShopify(false);
    }
  }

  // A choice made in another tab, or while this page sat in the back/forward cache.
  // Applied without reloading so nothing the visitor typed here is lost.
  function syncFromStorage() {
    var stored = readChoice();
    if (stored === null || stored === choice) return;
    var withdrawn = choice === true && !stored;
    choice = stored;
    consentUpdate(stored);
    hideBanner();
    if (stored) loadGTM();
    else if (withdrawn) deleteGaCookies();
    emit(stored);
  }

  /* ---------- banner ---------- */

  function setBannerHeight() {
    if (!banner || banner.hidden) return;
    d.documentElement.style.setProperty('--mp-consent-h', banner.offsetHeight + 'px');
  }

  function showBanner() {
    if (!banner) return;
    // Early in the DOM (right after the skip link) so keyboard users reach it first;
    // it is still displayed fixed at the bottom of the viewport.
    var skip = d.querySelector('body > .mp-skip');
    if (skip) d.body.insertBefore(banner, skip.nextSibling);
    else if (d.body.firstChild !== banner) d.body.insertBefore(banner, d.body.firstChild);
    banner.hidden = false;
    d.documentElement.classList.add('mp-consent-shown');
    setBannerHeight();
    if (typeof w.ResizeObserver === 'function') {
      new w.ResizeObserver(setBannerHeight).observe(banner);
    } else {
      w.addEventListener('resize', setBannerHeight);
    }
  }

  function hideBanner() {
    if (!banner || banner.hidden) return;
    banner.hidden = true;
    d.documentElement.classList.remove('mp-consent-shown');
    d.documentElement.style.removeProperty('--mp-consent-h');
  }

  /* ---------- dialog ---------- */

  function isUsable(el) {
    return !!(el && el.isConnected && typeof el.focus === 'function' && !el.closest('[hidden]'));
  }

  function openDialog(trigger) {
    initDom();
    if (!dialog) return;
    if (toggle) toggle.checked = choice === true; // pre-fill with the current choice
    if (dialog.hasAttribute('open')) return;
    opener = trigger || d.activeElement;
    if (nativeDialog) {
      try {
        dialog.showModal();
        return;
      } catch (e) {
        nativeDialog = false;
      }
    }
    dialog.classList.add('mp-consent-dialog--fallback');
    dialog.setAttribute('open', '');
    var first = dialog.querySelector('button, input:not([disabled]), a[href]');
    if (first) first.focus();
  }

  function closeDialog() {
    if (!dialog || !dialog.hasAttribute('open')) return;
    if (nativeDialog) {
      dialog.close(); // fires 'close' -> onDialogClose
    } else {
      dialog.removeAttribute('open');
      onDialogClose();
    }
  }

  function onDialogClose() {
    var o = opener;
    opener = null;
    if (isUsable(o) && d.activeElement !== o) {
      try {
        o.focus();
      } catch (e) {}
    }
  }

  /* ---------- wiring ---------- */

  function onClick(e) {
    var t = e.target;
    if (!t || typeof t.closest !== 'function') return;

    var o = t.closest('[data-mp-consent-open]');
    if (o) {
      e.preventDefault();
      openDialog(o);
      return;
    }

    var b = t.closest('[data-mp-consent-action]');
    if (!b) return;
    var act = b.getAttribute('data-mp-consent-action');
    if (act === 'accept') choose(true);
    else if (act === 'deny') choose(false);
    else if (act === 'save') choose(!!(toggle && toggle.checked));
    else if (act === 'close') closeDialog();
  }

  var domReady = false;
  function initDom() {
    if (domReady || !d.body) return;
    domReady = true;
    banner = d.getElementById('mp-consent-banner');
    dialog = d.getElementById('mp-consent-dialog');
    toggle = d.getElementById('mp-consent-analytics');

    if (dialog) {
      nativeDialog = typeof dialog.showModal === 'function' && typeof dialog.close === 'function';
      if (nativeDialog) {
        dialog.addEventListener('close', onDialogClose);
        // Click on the backdrop (outside the panel) closes without a choice.
        dialog.addEventListener('click', function (e) {
          if (e.target !== dialog) return;
          var r = dialog.getBoundingClientRect();
          if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) {
            closeDialog();
          }
        });
      } else {
        d.addEventListener('keydown', function (e) {
          if ((e.key === 'Escape' || e.key === 'Esc') && dialog.hasAttribute('open')) closeDialog();
        });
      }
    }

    if (choice === null) showBanner();
  }

  /* ---------- boot ---------- */

  w.MPConsent = {
    analytics: function () {
      return choice === true;
    },
    open: function () {
      openDialog();
    }
  };

  // Safety net if the head snippet is missing: defaults must exist before GTM.
  if (!w.__mpConsentDefault) {
    w.__mpConsentDefault = true;
    gtag('consent', 'default', {
      ad_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
      analytics_storage: 'denied',
      functionality_storage: 'granted',
      security_storage: 'granted'
    });
    if (choice === true) consentUpdate(true);
  }

  if (choice === true) loadGTM();

  d.addEventListener('click', onClick);
  w.addEventListener('pageshow', function (e) {
    if (e.persisted) syncFromStorage();
  });
  w.addEventListener('storage', function (e) {
    if (!e.key || e.key === KEY) syncFromStorage();
  });
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', initDom);
  else initDom();
})();
